export function getEmailDomain(email: string): string {
  const parts = email.split('@');
  if (parts.length !== 2) return '';
  const domain = parts[parts.length - 1];
  return domain.toLowerCase();
}
